import ConfirmedEmailPage from "./ConfirmedEmailPage";

export default ConfirmedEmailPage;